// Port of api/fuel/app/classes/controller/api/monty/subdomains/suggest.php
import DB from 'offline/db'
import Util from 'offline/util'
export default function(params) {
	var text = (params.text || '').toLowerCase()
	var exclude = params.exclude || [0]
	if (!text) return Promise.resolve({ session: { offline: true }, data: { suggestions: {} } })
	var rows = DB.query("SELECT subdomain_id, subdomain_name FROM subdomain WHERE LOWER(subdomain_name) LIKE '%" + text.replace(/'/g, "''") + "%' AND subdomain_id NOT IN(" + Util.in(exclude) + ") LIMIT 25")
	var suggestions = {}
	for (var i = 0; i < rows.length; i++) suggestions[rows[i].subdomain_id] = { id: rows[i].subdomain_id, name: rows[i].subdomain_name }
	return Promise.resolve({ session: { offline: true }, data: { suggestions: suggestions } })
}
